import { getStyle } from './stylesSelector';

export const getBackSVGViewBox = () => {
    return getStyle({
        ned: '0 0 24 24',
        watchman: '8 3 9 18'
    });
}